import { useEffect, useRef, useState } from 'react'

import { isEventKeyEscape } from '../../../../../utils/events'
import { GRETA_PANEL_ANIM_DURATION_MS } from '../../../GretaAIChat.constants'
import { getIsGretaAIChatExpanded } from '../../../GretaAIChat.utils'

export function useGretaAIChatPanel({
  isChatMenuOpen,
  isGenerating,
  mode,
  onMinimize,
  onStop,
  onToggleMode,
}) {
  const isExpanded = getIsGretaAIChatExpanded(mode)

  const [isModeTransition, setIsModeTransition] = useState(false)
  const modeTransitionTimerRef = useRef(null)

  useEffect(() => {
    const timerRef = modeTransitionTimerRef

    return () => clearTimeout(timerRef.current)
  }, [])

  // Size transition armed only during a mode change (see .modeTransition).
  function handleToggleMode() {
    setIsModeTransition(true)
    onToggleMode()

    clearTimeout(modeTransitionTimerRef.current)
    modeTransitionTimerRef.current = setTimeout(
      () => setIsModeTransition(false),
      GRETA_PANEL_ANIM_DURATION_MS
    )
  }

  function handleKeyDown(event) {
    if (isEventKeyEscape(event) && !event.defaultPrevented && !isChatMenuOpen) {
      if (isGenerating) {
        onStop()
      } else {
        onMinimize()
      }
    }
  }

  return { handleKeyDown, handleToggleMode, isExpanded, isModeTransition }
}
